// extracted by mini-css-extract-plugin
export default {"flavor_option":"pN","out_of_stock_text":"qN","out_of_stock":"rN","flavor_option_image":"sN","flavor_option_info":"tN","flavor_option_title":"uN","flavor_option_limited":"vN","flavor_option_amount_wrapper":"wN","flavor_option_amount_button":"xN","zero_amount":"yN","no_flavors":"zN","no_flavors_active":"AN","flavor_option_select_wrapper":"BN","flavor_option_select_wrapper__selected":"CN"};
    if(module.hot) {
      // 1715091680139
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  